import { handleValidationChange } from "../CommonValidation";

export const validateMenu = (data, packageDetails, setIsError) => {
  var isValid = true;

  if (data?.is_modifier === "0" && (!data.categories || data.categories === "")) {
    handleValidationChange("categories", true, setIsError);
    isValid = false;
  } else {
    handleValidationChange("categories", false, setIsError);
  }

  if (!data.name || data.name === "") {
    handleValidationChange("name", true, setIsError);
    isValid = false;
  } else {
    handleValidationChange("name", false, setIsError);
  }

  if (!data.price || data.price === "") {
    handleValidationChange("price", true, setIsError);
    isValid = false;
  } else {
    handleValidationChange("price", false, setIsError);
  }

  if (!data.item_code||data.item_code === "") {
    handleValidationChange("item_code", true, setIsError);
    isValid = false;
  } else {
    handleValidationChange("item_code", false, setIsError);
  }

  if (!data.menu_location||data.menu_location === "") {
    handleValidationChange("menu_location", true, setIsError);
    isValid = false;
  } else {
    handleValidationChange("menu_location", false, setIsError);
  }

  if (!data.default_printer||data.default_printer === "") {
    handleValidationChange("default_printer", true, setIsError);
    isValid = false;
  } else {
    handleValidationChange("default_printer", false, setIsError);
  }

  if (data.is_package === "1") {
    packageDetails.map((data) => {
      if (data === "") {
        handleValidationChange("is_package", true, setIsError);
        isValid = false;
      }
    });
  } else {
    handleValidationChange("is_package", false, setIsError);
    // isValid=true
  }

  return isValid;
};
